import SiparisList from "./Modules/Siparisler/SiparisList";
import SiparisCancelRefund from "./Modules/Siparisler/SiparisCancelRefund";

export default {
  namespaced: true,
  modules: {
    SiparisList,
    SiparisCancelRefund,
  },
};
